import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueActivityCreateFormMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      forms: {
        activityCreate: {
          cancel: "取消",
          prevStep: "上一步",
          nextStep: "下一步",
          finishStep: "发布演练",
          closeConfirmTitle: "确认关闭创建流程？",
          closeConfirmContent: "演练 {code} 已创建；现在关闭会保留已创建结果。",
          closeConfirmOk: "关闭并保留结果",
          closeConfirmCancel: "继续配置",
          createdTag: "已创建 {code}",
          stepBasicsTitle: "第一步 基本信息",
          stepBasicsDescription: "选择演练方案、发布版本、时间和基础说明。",
          stepBasicsNotice:
            "本次演练必须从已发布方案版本发起；请先选择演练方案和发布版本，并补齐基础信息。",
          stepRulesTitle: "第二步 规则与创建",
          stepRulesDescription: "确认执行规则，并正式创建演练活动。",
          stepRulesNotice:
            "这一步会真实调用后端创建活动；创建成功后可以快配成员，也可以先保留草稿。",
          stepMembersTitle: "第三步 成员与席位",
          stepMembersDescription:
            "复用详情页同一成员与席位工作区，可直接配置成员、角色、阵营和席位，也可以跳过后继续。",
          stepMembersNotice: "本步是可选快配，不再要求发起时立即放满席位。",
          stepMembersOptionalDescription:
            "本步骤和活动详情页“成员与席位”共用同一套槽位化配置；发布演练前，后端 schedule-readiness 会检查成员和执行席位是否补齐。",
          stepFinishTitle: "第四步 草稿交接与发布确认",
          stepFinishDescription: "查看草稿交接、发布检查和下一步入口。",
          stepFinishNotice: "演练已创建为草稿，发布前必须通过后端 readiness 检查。",
          summaryCardTitle: "创建摘要",
          designCardTitle: "活动设计快照",
          finishCardTitle: "草稿摘要",
          nameLabel: "演练名称",
          nameRequired: "请输入演练名称",
          nameMax: "演练名称不能超过 255 个字符",
          schemeLabel: "演练方案",
          schemeRequired: "请选择演练方案",
          schemePickerTitle: "查找带回演练方案",
          schemePickerConfirm: "带回演练方案",
          schemePickerPick: "查找带回",
          schemePickerClear: "清空",
          schemePickerDisplayPlaceholder: "请选择已发布演练方案",
          schemePickerEmpty: "暂无可带回的已发布演练方案",
          schemePickerSelectFirst: "请先选择一个演练方案",
          schemePickerLoadFailed: "演练方案加载失败",
          schemeVersionLabel: "发布版本",
          schemeVersionRequired: "请选择发布版本",
          reviewRequiredLabel: "裁判复核",
          globalRankingEnabledLabel: "开启全局排名",
          scheduledStartLabel: "计划开始时间",
          scheduledStartRequired: "请选择计划开始时间",
          scheduledEndLabel: "计划结束时间",
          scheduledEndRequired: "请选择计划结束时间",
          timeRangeInvalid: "计划结束时间必须晚于计划开始时间",
          descriptionLabel: "演练说明",
          createFirstError: "请先完成演练创建，再进行成员绑定。",
          membersLabel: "活动成员",
          membersRequired: "请至少添加 1 个活动成员",
          membersSkippedDraftSaved: "已保留草稿，可稍后在详情页配置成员与席位。",
          addMemberRow: "添加活动成员",
          memberUserLabel: "成员",
          memberUserRequired: "请选择活动成员",
          memberRoleLabel: "活动角色",
          memberRoleRequired: "请选择至少 1 个活动角色",
          memberCampLabel: "所属阵营",
          memberCampRequired: "执行角色必须选择所属阵营",
          memberSeatLabel: "绑定席位",
          noTasksHint: "当前活动设计没有任务快照。",
          noDesignHint: "当前活动没有可用设计快照，请确认来源方案版本已满足发起条件。",
          designCampCount: "阵营数",
          designSeatCount: "席位数",
          designTaskCount: "任务数",
          designSource: "来源",
          finishMembersCount: "成员数",
          finishSeatCount: "席位数",
          finishHint:
            "如果发布检查未通过，请先进入“成员与席位”工作区补齐执行角色和席位绑定；通过后可直接发布演练。",
          finishDraftNoticeTitle: "草稿已创建，可以先交接再补齐",
          finishDraftNoticeDescription:
            "创建流程不再强制把所有人立即放到席位；当前草稿可进入详情继续配置，真正发布时以后端 readiness 为准。",
          finishReadinessCardTitle: "发布前后端检查",
          finishReadinessLoadingTitle: "正在刷新发布检查",
          finishReadinessLoadingDescription:
            "系统正在读取活动成员、席位、拓扑、任务和报告模板等后端真相。",
          finishReadinessReadyTitle: "已满足发布演练条件",
          finishReadinessReadyDescription:
            "后端 readiness 已通过，可以点击底部“发布演练”按钮进入已排期状态。",
          finishReadinessBlockedTitle: "暂不能发布演练",
          finishReadinessBlockedDescription: "以下后端检查项仍需补齐：",
          finishOpenDetail: "保存草稿并进入详情",
          finishOpenMembersWorkspace: "继续配置成员与席位",
          finishRefreshReadiness: "刷新发布检查",
          scheduleReadinessBlockedToast: "发布检查未通过，请先补齐阻断项再发布演练。",
          summarySchemeVersion: "来源：{scheme} / {version}",
          summaryTimeWindow: "时间：{start} 至 {end}",
          summaryNoTimeWindow: "时间：暂未设置计划时间",
          readinessSelectVersionTitle: "先选择发布方案版本",
          readinessSelectVersionDescription: "只有选定方案版本后，系统才能校验是否允许发起演练。",
          readinessLoadingTitle: "正在校验方案版本发起条件",
          readinessLoadingDescription:
            "系统正在读取拓扑绑定、阵营映射、任务评分配置、报告模板等创建前置条件。",
          readinessReadyTitle: "方案版本已满足发起演练条件",
          readinessReadyDescription:
            "当前选择的方案版本 {scheme} / {version} 已满足发起演练条件，可以继续创建演练。",
          readinessBlockedTitle: "方案版本还不能发起演练",
          readinessBlockedDescription:
            "以下缺项会阻断从该方案版本创建演练，必须先回到方案设计工作台补齐：",
          readinessUnavailableTitle: "无法确认方案版本发起条件",
          readinessUnavailableDescription: "发起条件校验失败，当前不能继续按该方案版本创建演练。",
          readinessBlockedToast: "方案版本发起条件未满足，不能继续创建演练。",
          readinessBackendRejectedToast:
            "后端拒绝了这次创建：方案版本发起条件仍未满足，请先补齐缺项。",
        },
      },
    },
  },
  en: {
    redblue: {
      forms: {
        activityCreate: {
          cancel: "Cancel",
          prevStep: "Previous",
          nextStep: "Next",
          finishStep: "Publish Activity",
          closeConfirmTitle: "Close the creation flow?",
          closeConfirmContent:
            "Activity {code} has already been created. Closing now will keep the created result.",
          closeConfirmOk: "Close and Keep Result",
          closeConfirmCancel: "Continue Editing",
          createdTag: "Created {code}",
          stepBasicsTitle: "Step 1 Basics",
          stepBasicsDescription:
            "Choose the scheme, published version, schedule, and basic description.",
          stepBasicsNotice:
            "This activity must be launched from a published scheme version. Choose the scheme and published version, then complete the basic information.",
          stepRulesTitle: "Step 2 Rules and Create",
          stepRulesDescription: "Confirm execution rules and create the activity for real.",
          stepRulesNotice:
            "This step makes the real backend create request. After that, you can quick-configure members or keep the draft first.",
          stepMembersTitle: "Step 3 Members and Seats",
          stepMembersDescription:
            "Reuse the same Members and Seats workspace from detail to configure members, roles, camps, and seats, or skip and continue later.",
          stepMembersNotice:
            "This optional quick setup no longer requires every seat to be filled during creation.",
          stepMembersOptionalDescription:
            "This step and the activity detail Members and Seats tab share the same slot-based workspace. Before publishing, backend schedule-readiness checks that members and execution seats are complete.",
          stepFinishTitle: "Step 4 Draft Handoff and Publish Check",
          stepFinishDescription:
            "Review the draft handoff, publish checks, and next-step entry points.",
          stepFinishNotice:
            "The activity has been created as a draft. Publishing must pass the backend readiness check.",
          summaryCardTitle: "Creation Summary",
          designCardTitle: "Activity Design Snapshot",
          finishCardTitle: "Draft Summary",
          nameLabel: "Activity Name",
          nameRequired: "Enter an activity name",
          nameMax: "Activity name must be 255 characters or fewer",
          schemeLabel: "Scheme",
          schemeRequired: "Select a scheme",
          schemePickerTitle: "Find and Return Scheme",
          schemePickerConfirm: "Return Scheme",
          schemePickerPick: "Find",
          schemePickerClear: "Clear",
          schemePickerDisplayPlaceholder: "Select a published scheme",
          schemePickerEmpty: "No published schemes are available",
          schemePickerSelectFirst: "Select a scheme first",
          schemePickerLoadFailed: "Failed to load schemes",
          schemeVersionLabel: "Published Version",
          schemeVersionRequired: "Select a published version",
          reviewRequiredLabel: "Require Judge Review",
          globalRankingEnabledLabel: "Enable Global Ranking",
          scheduledStartLabel: "Planned Start Time",
          scheduledStartRequired: "Select a planned start time",
          scheduledEndLabel: "Planned End Time",
          scheduledEndRequired: "Select a planned end time",
          timeRangeInvalid: "The planned end time must be later than the planned start time",
          descriptionLabel: "Activity Description",
          createFirstError: "Create the activity first before binding members.",
          membersLabel: "Activity Members",
          membersRequired: "Add at least one activity member",
          membersSkippedDraftSaved:
            "Draft kept. You can configure members and seats later from the detail page.",
          addMemberRow: "Add Member",
          memberUserLabel: "Member",
          memberUserRequired: "Select a member",
          memberRoleLabel: "Activity Roles",
          memberRoleRequired: "Select at least one activity role",
          memberCampLabel: "Camp",
          memberCampRequired: "Execution roles must choose a camp",
          memberSeatLabel: "Seat",
          noTasksHint: "No task snapshot is available for this activity design.",
          noDesignHint:
            "No design snapshot is available yet. Confirm the source scheme version is ready to launch an activity.",
          designCampCount: "Camp Count",
          designSeatCount: "Seat Count",
          designTaskCount: "Task Count",
          designSource: "Source",
          finishMembersCount: "Member Count",
          finishSeatCount: "Seat Count",
          finishHint:
            "If the publish check is blocked, open Members and Seats first to complete execution roles and seat bindings. Once ready, publish directly from here.",
          finishDraftNoticeTitle: "Draft created; handoff can happen before seats are complete",
          finishDraftNoticeDescription:
            "Creation no longer forces every participant into a seat immediately. Continue in detail when needed; publishing still follows backend readiness.",
          finishReadinessCardTitle: "Backend Publish Check",
          finishReadinessLoadingTitle: "Refreshing publish readiness",
          finishReadinessLoadingDescription:
            "The system is reading backend truth for members, seats, topology, tasks, and report templates.",
          finishReadinessReadyTitle: "Ready to publish",
          finishReadinessReadyDescription:
            "Backend readiness passed. Use the bottom Publish Activity button to move this activity to scheduled.",
          finishReadinessBlockedTitle: "Activity cannot be published yet",
          finishReadinessBlockedDescription: "Complete these backend readiness items first:",
          finishOpenDetail: "Keep Draft and Open Detail",
          finishOpenMembersWorkspace: "Continue Members and Seats",
          finishRefreshReadiness: "Refresh Publish Check",
          scheduleReadinessBlockedToast:
            "Publish readiness is blocked. Complete the listed items before publishing.",
          summarySchemeVersion: "Source: {scheme} / {version}",
          summaryTimeWindow: "Schedule: {start} to {end}",
          summaryNoTimeWindow: "Schedule: not set yet",
          readinessSelectVersionTitle: "Select a published scheme version first",
          readinessSelectVersionDescription:
            "The system can only validate activity launch conditions after a concrete scheme version is selected.",
          readinessLoadingTitle: "Checking scheme-version launch conditions",
          readinessLoadingDescription:
            "The system is loading topology binding, camp mapping, task scoring config, report templates, and other create prerequisites.",
          readinessReadyTitle: "This scheme version is ready to launch an activity",
          readinessReadyDescription:
            "The selected scheme version {scheme} / {version} satisfies the activity launch conditions and can continue into activity creation.",
          readinessBlockedTitle: "This scheme version cannot launch an activity yet",
          readinessBlockedDescription:
            "The following missing items block activity creation from this scheme version and must be fixed in the scheme designer first:",
          readinessUnavailableTitle: "Scheme-version launch conditions are unavailable",
          readinessUnavailableDescription:
            "The launch-condition validation failed, so activity creation from this scheme version cannot continue right now.",
          readinessBlockedToast:
            "Scheme-version launch conditions are not satisfied, so activity creation cannot continue.",
          readinessBackendRejectedToast:
            "The backend rejected this create request because the scheme-version launch conditions are still incomplete.",
        },
      },
    },
  },
  ja: {
    redblue: {
      forms: {
        activityCreate: {
          cancel: "キャンセル",
          prevStep: "前へ",
          nextStep: "次へ",
          finishStep: "演習を公開",
          closeConfirmTitle: "作成フローを閉じますか？",
          closeConfirmContent:
            "演習 {code} はすでに作成されています。ここで閉じても作成結果は保持されます。",
          closeConfirmOk: "閉じて結果を保持",
          closeConfirmCancel: "引き続き設定する",
          createdTag: "作成済み {code}",
          stepBasicsTitle: "第1步 基本情報",
          stepBasicsDescription: "プラン、公開済み版、時間、基本説明を設定します。",
          stepBasicsNotice:
            "この演習は公開済みプラン版から起動する必要があります。プランと公開済み版を選択し、基本情報を入力してください。",
          stepRulesTitle: "第2步 ルールと作成",
          stepRulesDescription: "実行ルールを確認し、演習活動を実際に作成します。",
          stepRulesNotice:
            "この手順で実際にバックエンドへ作成リクエストを送ります。作成後はメンバーを簡易設定するか、下書きとして保持できます。",
          stepMembersTitle: "第3步 メンバーと席位",
          stepMembersDescription:
            "詳細ページと同じ「メンバーと席位」工作区を再利用し、メンバー、ロール、陣営、席位を設定できます。後で続けることもできます。",
          stepMembersNotice:
            "この手順は任意の簡易設定であり、作成時点で全席位を埋める必要はありません。",
          stepMembersOptionalDescription:
            "この手順と活動詳細の「メンバーと席位」は同じスロット型工作区を共有します。公開前には backend schedule-readiness がメンバーと実行席位の充足を確認します。",
          stepFinishTitle: "第4步 下書き引き継ぎと公開確認",
          stepFinishDescription: "下書き引き継ぎ、公開チェック、次の入口を確認します。",
          stepFinishNotice:
            "演習は下書きとして作成されました。公開には backend readiness の通過が必要です。",
          summaryCardTitle: "作成サマリー",
          designCardTitle: "活動設計スナップショット",
          finishCardTitle: "下書きサマリー",
          nameLabel: "演習名",
          nameRequired: "演習名を入力してください",
          nameMax: "演習名は 255 文字以内で入力してください",
          schemeLabel: "プラン",
          schemeRequired: "プランを選択してください",
          schemePickerTitle: "プランを検索して反映",
          schemePickerConfirm: "プランを反映",
          schemePickerPick: "検索",
          schemePickerClear: "クリア",
          schemePickerDisplayPlaceholder: "公開済みプランを選択してください",
          schemePickerEmpty: "反映できる公開済みプランはありません",
          schemePickerSelectFirst: "先にプランを選択してください",
          schemePickerLoadFailed: "プランの読み込みに失敗しました",
          schemeVersionLabel: "公開済み版",
          schemeVersionRequired: "公開済み版を選択してください",
          reviewRequiredLabel: "審判レビュー",
          globalRankingEnabledLabel: "全体ランキングを有効化",
          scheduledStartLabel: "予定開始時刻",
          scheduledStartRequired: "予定開始時刻を選択してください",
          scheduledEndLabel: "予定終了時刻",
          scheduledEndRequired: "予定終了時刻を選択してください",
          timeRangeInvalid: "予定終了時刻は予定開始時刻より後である必要があります",
          descriptionLabel: "演習説明",
          createFirstError: "先に演習を作成してからメンバーを紐付けてください。",
          membersLabel: "活動メンバー",
          membersRequired: "少なくとも 1 人の活動メンバーを追加してください",
          membersSkippedDraftSaved:
            "下書きを保持しました。メンバーと席位は後で詳細ページから設定できます。",
          addMemberRow: "メンバーを追加",
          memberUserLabel: "メンバー",
          memberUserRequired: "メンバーを選択してください",
          memberRoleLabel: "活動ロール",
          memberRoleRequired: "少なくとも 1 つの活動ロールを選択してください",
          memberCampLabel: "所属陣営",
          memberCampRequired: "実行ロールは所属陣営を選択する必要があります",
          memberSeatLabel: "席位",
          noTasksHint: "この活動設計にはタスクスナップショットがありません。",
          noDesignHint:
            "利用可能な設計スナップショットがありません。作成元のプラン版が演習起動条件を満たしているか確認してください。",
          designCampCount: "陣営数",
          designSeatCount: "席位数",
          designTaskCount: "タスク数",
          designSource: "作成元",
          finishMembersCount: "メンバー数",
          finishSeatCount: "席位数",
          finishHint:
            "公開チェックがブロックされた場合は、先に「メンバーと席位」で実行ロールと席位紐付けを補完してください。通過後、この画面から直接公開できます。",
          finishDraftNoticeTitle: "下書きは作成済みです。席位完成前でも引き継げます",
          finishDraftNoticeDescription:
            "作成時に全参加者をすぐ席位へ配置する必要はありません。必要に応じて詳細で続け、公開は backend readiness に従います。",
          finishReadinessCardTitle: "Backend 公開チェック",
          finishReadinessLoadingTitle: "公開 readiness を更新しています",
          finishReadinessLoadingDescription:
            "メンバー、席位、トポロジー、タスク、レポートテンプレートの backend truth を読み込んでいます。",
          finishReadinessReadyTitle: "公開条件を満たしています",
          finishReadinessReadyDescription:
            "Backend readiness は通過済みです。下部の「演習を公開」ボタンで予定済みに移行できます。",
          finishReadinessBlockedTitle: "まだ演習を公開できません",
          finishReadinessBlockedDescription: "先に以下の backend readiness 項目を補完してください:",
          finishOpenDetail: "下書きを保持して詳細へ",
          finishOpenMembersWorkspace: "メンバーと席位を続ける",
          finishRefreshReadiness: "公開チェックを更新",
          scheduleReadinessBlockedToast:
            "公開 readiness がブロックされています。阻断項目を補完してから公開してください。",
          summarySchemeVersion: "作成元: {scheme} / {version}",
          summaryTimeWindow: "時間: {start} から {end}",
          summaryNoTimeWindow: "時間: まだ設定されていません",
          readinessSelectVersionTitle: "先に公開済みプラン版を選択してください",
          readinessSelectVersionDescription:
            "具体的なプラン版が選ばれてはじめて、演習起動条件を検証できます。",
          readinessLoadingTitle: "プラン版の起動条件を確認しています",
          readinessLoadingDescription:
            "トポロジー紐付け、陣営マッピング、タスク採点設定、レポートテンプレートなど、作成前提条件を読み込んでいます。",
          readinessReadyTitle: "このプラン版は演習起動条件を満たしています",
          readinessReadyDescription:
            "選択中のプラン版 {scheme} / {version} は演習起動条件を満たしており、このまま演習作成を続行できます。",
          readinessBlockedTitle: "このプラン版ではまだ演習を起動できません",
          readinessBlockedDescription:
            "以下の不足項目がこのプラン版からの演習作成をブロックしています。先にプラン設計ワークベンチで補完してください:",
          readinessUnavailableTitle: "プラン版の起動条件を確認できません",
          readinessUnavailableDescription:
            "起動条件の検証に失敗したため、このプラン版からの演習作成は続行できません。",
          readinessBlockedToast:
            "プラン版の起動条件を満たしていないため、演習作成を続けられません。",
          readinessBackendRejectedToast:
            "バックエンドがこの作成を拒否しました。プラン版の起動条件がまだ不足しています。",
        },
      },
    },
  },
};
